import Styles from './UploadsDrawer.module.scss'
import { useUploadsTab } from '../UploadsTabContext'
import { geoShapes } from 'components/Design/ElementsTab/components/shapes'
import { maskShapes } from 'components/Design/ElementsTab/components/shapes'
import { icons } from './components/icons'
import { BasicsCard } from './components/BasicsCard'
import { Text } from 'blaze-ui/Text/Text'

const SHAPES_TO_SHOW = 4

export const Basics = () => {
  const { openPanel } = useUploadsTab()

  const geoShapesToDisplay = geoShapes.slice(0, SHAPES_TO_SHOW)
  const maskShapesToDisplay = maskShapes.slice(0, SHAPES_TO_SHOW)
  const iconsToDisplay = icons.slice(0, SHAPES_TO_SHOW)

  return (
    <div>
      <div className={Styles.horizontalContainer}>
        <Text variant="smallList" color="var(--dark-80)">
          Basics
        </Text>
      </div>
      <div className={Styles.groupItems}>
        <BasicsCard
          onPress={() => openPanel({ panel: 'shapes', panelProps: {} })}
          icons={geoShapesToDisplay.map((shape) => shape.component)}
          label="Shapes"
        />
        <BasicsCard
          onPress={() => openPanel({ panel: 'masks', panelProps: {} })}
          icons={maskShapesToDisplay.map((shape) => shape.component)}
          label="Frames"
        />
        <BasicsCard
          onPress={() => openPanel({ panel: 'icons', panelProps: {} })}
          icons={iconsToDisplay}
          label="Icons"
        />
      </div>
    </div>
  )
}
